import ruleApi from '@/api/rule';

const SET_RULES = 'SET_RULES';
const ADD_RULE = 'ADD_RULE';
const DELETE_RULE = 'DELETE_RULE';
const UPDATE_RULE = 'UPDATE_RULE';

const state = {
  rules: [],
  rulesTimetamp: 0
};

const getters = {
  getRules: state => {
    return state.rules;
  }
};

const mutations = {
  [SET_RULES] (state, rules) {
    state.rules = rules;
    state.rulesTimetamp = new Date().getTime();
  },
  [ADD_RULE] (state, rule) {
    state.rules.push(rule);
  },
  [UPDATE_RULE] (state, rule) {
    const index = state.rules.map(e => e.id).indexOf(rule.id);
    state.rules.splice(index, 1, rule);
  },
  [DELETE_RULE] (state, id) {
    const index = state.rules.map(e => e.id).indexOf(id);
    state.rules.splice(index, 1);
  }
};

const actions = {
  retrieveRulesForced ({ state, commit }, { context, tags }) {
    ruleApi.getRules(context, tags).then(data => {
      commit(SET_RULES, data);
    });
  },
  retrieveRules ({ state, commit }, { context, tags }) {
    if (new Date().getTime() - state.rulesTimetamp < 60000) {
      return;
    }

    ruleApi.getRules(context, tags).then(data => {
      commit(SET_RULES, data);
    });
  },
  createRule ({ commit }, { context, rule }) {
    return new Promise((resolve, reject) => {
      ruleApi.createRule(context, rule)
        .then(data => {
          commit(ADD_RULE, data);
          resolve();
        }, error => {
          reject(error);
        });
    });
  },
  updateRule ({ commit }, { context, rule }) {
    return new Promise((resolve, reject) => {
      ruleApi.updateRule(context, rule)
        .then(data => {
          commit(UPDATE_RULE, data);
          resolve();
        }, error => {
          reject(error);
        });
    });
  },
  deleteRule ({ commit }, { context, id }) {
    return new Promise((resolve, reject) => {
      ruleApi.deleteRule(context, id)
        .then(() => {
          commit(DELETE_RULE, id);
          resolve();
        }, error => {
          reject(error);
        });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/rule/index.js